<template>
  <div class="insureOrderQuery">
    <div v-if="state > 0" class="breadNav">
      <div :key="key" v-for="(item, key) of stateNav"
        :class="['breadItem', key === state && 'active', key > state && 'hide']" @click="stateChange(key)">
        {{ item.value }}
      </div>
    </div>
    <div v-if="state === '0'">
      <query-form @state-change="stateChange"></query-form>
    </div>
    <div v-if="state === '1'">
      <query-list @state-change="stateChange" @select-detail="selectDetail"></query-list>
    </div>
    <div v-if="state === '2'">
      <query-detail @state-change="stateChange" :code="code"></query-detail>
    </div>
  </div>
</template>

<script>
  import QueryDetail from './queryDetail.vue';
  import QueryList from './queryList.vue';
  import QueryForm from "./queryForm.vue";
  export default {
    name: "insureOrderQuery",
    components: {
      QueryForm,
      QueryDetail,
      QueryList
    },
    data() {
      return {
        state: "0",
        code: '',
        stateNav: {
          0: {
            value: "保单查询",
          },
          1: {
            value: "查询结果",
          },
          2: {
            value: "保单详情",
          },
        },
      };
    },

    created() {},
    mounted() {},
    methods: {
      stateChange(key) {
        console.log(key)
        this.state = key;
      },
      selectDetail(code) {
        console.log(code)
        this.code = code;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .insureOrderQuery {
    width: 1024px;
    margin: 0 auto;
    width: 940px;
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
    padding: 40px;
    .breadNav {
      display: flex;
      width: 100%;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
      cursor: pointer;

      .active {
        color: #2488CA;
      }

      .hide {
        display: none;
      }

      .breadItem:not(:first-child) {
        &::before {
          content: ">";
          padding-left: 4px;
        }
      }
    }
  }
</style>